module.exports = __webpack_public_path__ + "static/media/google.9e5690de.svg";